<label class="checkbox-container" [class.disabled]="disabled">
  <input
    type="checkbox"
    class="checkbox-input"
    [checked]="checked"
    [disabled]="disabled"
    (change)="toggleCheckbox()"
  />
  <span class="checkbox-custom" [class.checked]="checked && !indeterminate" [class.indeterminate]="indeterminate">
    @if (checked && !indeterminate) {
      <svg
        class="checkbox-icon visible"
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.766 0.790399L4.29653 7.62913L0 4.04827L0.810667 3.07547L4.11413 5.82793L8.778 0L9.766 0.790399Z" fill="white"/>
      </svg>
    }
    @if (indeterminate) {
      <svg
        class="checkbox-icon visible"
        width="10"
        height="2"
        viewBox="0 0 10 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="10" height="2" rx="1" fill="white"/>
      </svg>
    }
  </span>
  <span class="checkbox-label" *ngIf="label">{{ label }}</span>
</label>
